export default __webpack_public_path__ + "assets/models/e4ed0ee4a2d45f6f81b11a4d135fb229.glb";